import React from 'react';
const ConnectSVG = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M8.13846 11.4326C6.93115 11.4326 5.94336 10.4448 5.94336 9.23752V7.04242H10.3336V9.23752C10.3336 10.4448 9.34576 11.4326 8.13846 11.4326Z"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.04102 4.84732V7.04242"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.23633 4.84732V7.04242"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.13843 11.4326V13.1338C8.13843 14.396 6.87625 15.3289 5.72382 14.8899C2.87019 13.8472 0.8946 11.0485 1.00435 7.8656C1.16899 4.18881 4.18725 1.17055 7.86404 1.00592C11.925 0.841285 15.2725 4.13393 15.2725 8.13999C15.2725 11.2131 13.3518 13.7924 10.6628 14.835"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ConnectSVG;
